import * as React from 'react';

import SvgIcon, { SvgIconProps } from './SvgIcon';

const IcPersonGhost: React.SFC<SvgIconProps> = ({ children, ...rest }) => {
  /* tslint:disable:max-line-length */
  return (
    <SvgIcon viewBox="1 2 70 70" {...rest}>
      <path d="M44.7,38.9l-4.6-1.5c1.2-1.1,1.9-2.6,1.9-4.4v-5c0-3.3-2.7-6-6-6s-6,2.7-6,6v5c0,1.7,0.7,3.3,1.9,4.4l-4.6,1.5c-3.2,1.1-5.3,4-5.3,7.4V50h28v-3.7C50,42.9,47.9,40,44.7,38.9z M33,27.8c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3v5.5c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3V27.8z M47,47H25v-1c0-2.1,1.3-3.9,3.3-4.5l7.7-2.6l7.7,2.6c2,0.7,3.3,2.5,3.3,4.5V47z" />
    </SvgIcon>
  );
};

export default IcPersonGhost;



// WEBPACK FOOTER //
// ./src/common/components/svg/IcPersonGhost.tsx